import { render, staticRenderFns } from "./DatosUsuario.vue?vue&type=template&id=03422221&scoped=true"
import script from "./DatosUsuario.vue?vue&type=script&lang=js"
export * from "./DatosUsuario.vue?vue&type=script&lang=js"
import style0 from "./DatosUsuario.vue?vue&type=style&index=0&id=03422221&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03422221",
  null
  
)

export default component.exports